import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { UsersDataService } from './users-data.service';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ReviewsColumnsService {

  public users: User[] = [];
  public statusesOptions = [{
    value: 'Pending',
    label: 'STATUSESPENDING',
    css: 'primary'
  }, {
    value: 'Validated',
    label: 'STATUSESVALIDATED',
    css: 'success'
  }, {
    value: 'Deleted',
    label: 'STATUSESDELETED',
    css: 'warning'
  }];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,
    private usersDataService: UsersDataService,

  ) {
    this.getUsers()
  }

  getUsers(offset: number = 0): void {
    const cacheKey: string = 'users.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.users = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.usersDataService.getUsers(parameters).subscribe((response: UsersResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.users = response.results;
        } else {
          this.users = this.users.concat(response.results);
        }
        if (response.inlineCount > this.users.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getUsers(offset);
        }
        response.results = this.users;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('reviews.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'entity', sortField: 'entity', title: this.translate.instant('ENTITY'), show: (this.navigation.getParamValue('reviews.entity.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'foreignKey', sortField: 'foreignKey', title: this.translate.instant('FOREIGNKEY'), show: (this.navigation.getParamValue('reviews.foreignKey.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'value', sortField: 'value', title: this.translate.instant('VALUE'), show: (this.navigation.getParamValue('reviews.value.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'subject', sortField: 'subject', title: this.translate.instant('SUBJECT'), show: (this.navigation.getParamValue('reviews.subject.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'body', sortField: 'body', title: this.translate.instant('BODY'), show: (this.navigation.getParamValue('reviews.body.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'status', sortField: 'status', title: this.translate.instant('STATUS'), show: (this.navigation.getParamValue('reviews.status.showFiled', true) && true), displayInList: true, type: 'enumValue', filterData: this.statusesOptions},
      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('CREATEDAT'), show: (this.navigation.getParamValue('reviews.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'creatorUser', title: this.translate.instant('CREATORUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('reviews.creatorUser.showFiled', false) && true), displayInList: true, filterField: 'creatorUser.id', displayField: 'username', sortField: 'creatorUser.username', url: 'users' },
      { field: 'modifiedAt', sortField: 'modifiedAt', title: this.translate.instant('MODIFIEDAT'), show: (this.navigation.getParamValue('reviews.modifiedAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'modifierUser', title: this.translate.instant('MODIFIERUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('reviews.modifierUser.showFiled', false) && true), displayInList: true, filterField: 'modifierUser.id', displayField: 'username', sortField: 'modifierUser.username', url: 'users' },
      { field: 'actions', title: this.translate.instant('ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
